<template>
    <div class="create-app">
        <top-header></top-header>
        <div class="create-app-cont">
            <left-aside :reload="reload" @changeReload="changeReload"></left-aside>
            <router-view></router-view>
        </div>
        <div class="cover-view" v-show="is_show_cover">
            <div class="view-app">
                <div class="phone-img"><img src="./images/Image 1.png"></div>
                <div class="close" @click="closeViewCover"><img src="./images/Group 10.png"></div>
            </div>
        </div>
        <div class="cover-view" v-show="is_show_authorize">
            <div class="result-cont">
                <div class="close" @click="closeAutnorizeCover"><i class="el-icon-close"></i></div>
                <h3 class="result-title">
                    <div :class="app_result.class"></div>
                    {{app_result.tip}}
                </h3>
                <ul>
                    <li>
                        <div :class="result.appParam"></div>
                        接口配置
                    </li>
                    <li>
                        <div :class="result.appPage"></div>
                        页面配置
                    </li>
                    <li>
                        <div :class="result.appPay"></div>
                        支付配置
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import topHeader from '@/components/top-header'
import leftAside from '@/components/left-aside'
export default {
    data () {
        return {
            reload: false
        }
    },
    components: {
        topHeader,
        leftAside
    },
    methods: {
        closeViewCover () {
            this.$store.dispatch('closeCoverView')
        },
        closeAutnorizeCover () {
            this.$store.dispatch('closeCoverAuthorize')
            let {params} = this.$route
            this.reload = true
            this.$router.push(`/create-app/${params.id}/${this.app_result.router}`)
        },
        changeReload () {
            this.reload = false
        }
    },
    computed: {
        is_show_cover () {
            return this.$store.state.is_show_cover
        },
        is_show_authorize () {
            return this.$store.state.is_show_authorize
        },
        result () {
            let result = this.$store.state.result
            return {
                appParam: result.appParam ? "right" : "wrong",
                appPage: result.appPage ? "right" : "wrong",
                appPay: result.appPay ? "right" : "wrong"
            }
        },
        app_result () {
            let result = this.$store.state.result;
            if(!result.appParam) {
                return {
                    class: "warning",
                    router: 'param', 
                    tip: "发布失败，请检查接口设置"
                }
            }else if(!result.appPage) {
                return {
                    class: "warning",
                    router: 'page', 
                    tip: "发布失败，请检查页面设置"
                }
            }else if(!result.appPay) {
                return {
                    class: "warning",
                    router: 'pay', 
                    tip: "发布失败，请检查支付设置"
                }
            }else {
                return {
                    class: "success",
                    router: 'before-station', 
                    tip: "发布成功"
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import './scss/create-app.scss';
    div.wrong {
        background-image: url("./images/wrong.png");
    }
    div.right {
        background-image: url("./images/right.png");
    }
    div.warning {
        background-image: url("./images/warning.png");
    }
    div.success {
        background-image: url("./images/success.png");
    }
</style>





// WEBPACK FOOTER //
// src/pages/CreateApp/create-app.vue